export enum ImportFormatId {
    PAGA = 1,
    PAGA_Hierachy = 2,
    Visma = 3,
    Visma_Hierachy = 4,
    Agresso = 5,
    Aditro = 6,
    Identum_csv = 7,
    CatalystOne = 8,
    SD_Worx = 9,
    SAP_HR_csv = 10,
    SAP_HI_csv = 11,
    Xledger_HR = 12,
    Xledger_HI = 13,
    Simployer = 14,
    AFAS_HR = 15,
    AFAS_HI = 16,
    Visma_HR8 = 17,
    Visma_HR8_HI = 18,
    NA = 19,
    Mepco_HR = 20,
    Mepco_HI = 21,
    Mindkey_HR = 22,
    Mindkey_HI = 23,
    Personec_P_HR = 24,
    Personec_P_HI = 25,
    Visma_Agda = 26,
    Visma_Employee_HR = 27,
    Visma_Employee_HI = 28,
    Heroma_H = 29,
    'Visma_ROR' = 30,
    Visma_Agda_HI = 31,
    Heroma_SCIM_HR = 32,
    Heroma_API_HI = 33,
    Heroma_API_HR = 34,
    IST_SE = 35,
    Generic_Import = 38,
    Security_screening_CSV = 41,
}
